export const onlyDigits = (value = "") => String(value || "").replace(/\D/g, "");

export function formatCpfCnpj(value = "") {
  const digits = onlyDigits(value).slice(0, 14);
  if (digits.length <= 11) {
    return digits
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  return digits
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
}

export function formatCep(value = "") {
  return onlyDigits(value).slice(0, 8).replace(/^(\d{5})(\d{1,3})$/, "$1-$2");
}

export function formatTelefone(value = "") {
  const digits = onlyDigits(value).slice(0, 11);
  if (digits.length <= 10) {
    return digits
      .replace(/^(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{4})(\d{1,4})$/, "$1-$2");
  }
  return digits
    .replace(/^(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d{1,4})$/, "$1-$2");
}

function joinAddress({ logradouro, numero, bairro, complemento }) {
  return [logradouro, numero].filter(Boolean).join(", ")
    + (bairro ? ` - ${bairro}` : "")
    + (complemento ? ` (${complemento})` : "");
}

export async function fetchCnpjData(cpfCnpj) {
  const cnpj = onlyDigits(cpfCnpj);
  if (cnpj.length !== 14) throw new Error("Informe um CNPJ com 14 dígitos.");

  const response = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${cnpj}`);
  if (!response.ok) throw new Error("CNPJ não encontrado ou serviço indisponível.");
  const data = await response.json();

  return {
    nome: data.razao_social || data.nome_fantasia || "",
    cpf_cnpj: formatCpfCnpj(cnpj),
    email: data.email || "",
    telefone: formatTelefone(`${data.ddd_telefone_1 || ""}`),
    cep: formatCep(data.cep || ""),
    endereco: joinAddress({
      logradouro: data.logradouro,
      numero: data.numero,
      bairro: data.bairro,
      complemento: data.complemento,
    }).trim(),
    cidade: data.municipio || "",
    estado: data.uf || "",
  };
}

export async function fetchCepData(cepValue) {
  const cep = onlyDigits(cepValue);
  if (cep.length !== 8) throw new Error("Informe um CEP com 8 dígitos.");

  const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
  if (!response.ok) throw new Error("CEP não encontrado ou serviço indisponível.");
  const data = await response.json();
  if (data.erro) throw new Error("CEP não encontrado.");

  return {
    cep: formatCep(cep),
    endereco: joinAddress({
      logradouro: data.logradouro,
      bairro: data.bairro,
      complemento: data.complemento,
    }).trim(),
    cidade: data.localidade || "",
    estado: data.uf || "",
    uf: data.uf || "",
  };
}

export function mergeFilled(current, incoming) {
  return Object.fromEntries(
    Object.entries(incoming).map(([key, value]) => [key, value || current[key] || ""])
  );
}
